import { Component, inject, ChangeDetectionStrategy, DOCUMENT } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { API_URL } from '@app/core/services/api-token';
import { NotificationComponent } from '@app/features/notification/notification.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, NotificationComponent],
})
export class AppComponent {
  private readonly meta = inject(Meta);
  private readonly document = inject(DOCUMENT);

  constructor() {
    const apiUrl = inject(API_URL);
    this.meta.addTag({
      httpEquiv: 'Content-Security-Policy',
      content: `default-src 'self'; frame-src https://forms.office.com https://forms.cloud.microsoft; child-src https://forms.office.com https://forms.cloud.microsoft; script-src 'self'; style-src 'self' 'unsafe-inline'; img-src 'self' data:; connect-src 'self' ${apiUrl} https://login.microsoftonline.com; object-src 'none'`,
    });
  }

  hideLoginLoading() {
    this.document.getElementById('login-loading')?.remove();
  }
}
